<template>

    <modificador-form :idBusiness="idBusiness" :pag="pag" :idModificador="idModificador"></modificador-form>

</template>

<script>

    import ModificadorForm from "../../../Widgets/Modificadores/ModificadorForm";
    import swal from 'sweetalert2'
    export default {
        components: {
            ModificadorForm
        },
        data() {
            return {
                idBusiness: this.$route.params.idBusiness,
                idModificador: this.$route.params.idModificador,
                pag: this.$route.params.pag,
            }
        },
        created() {


            let action = this.idModificador ? this.$i18n.t("editar") : this.$i18n.t("nueva");
            this.$store.dispatch('setNameRoute', action + ' ' + this.$i18n.t("modificador"));

            this.getRestrictions();
        },
        methods: {

            getRestrictions() {

                var config = {
                    params: {
                        jwt: this.$store.getters.jwt,
                        idBusiness: this.idBusiness,
                        idRestriction: 14,
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getRestrictionsByTipo", config)
                    .then(function (response) {

                        if (!response.data.response) {

                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });

                            vm.$router.push({
                                name: 'configuracion'
                            })

                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });


            }


        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Configuracion/Modificadores/Modificador.vue